import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import type Router from "cc-frontend/router"
import type ModalManager from "cc-frontend/services/modal-manager"
import { tracked } from "tracked-built-ins"

export interface Signature {
  Args: {
    model: {
      school: Group
    }
    order: number
  }
  Blocks: {
    default?: any
  }
}

export default class SchoolSetup extends Component<Signature> {
  @service declare router: Router
  @service declare modalManager: ModalManager

  @tracked elementInserted = false

  @action didInsert(_element) {
    later(() => {
      this.elementInserted = true
    }, 250)
  }

  @action closeModal() {
    this.router.transitionTo("new-group.show")
  }

  @action editName() {
    this.modalManager.openModal("school/edit/name", {
      group: this.args.model.school,
    })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Setup": typeof SchoolSetup
  }
}
